import { useAuth0 } from '@auth0/auth0-react'
import Cookies from 'js-cookie'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'

import i18n from '@/i18n/i18n'
import { checkAndClearDualCanvas } from '@/store/appSlice'
import {
  HeaderKey,
  setAuthorizationToDefaultHeaders,
  setHeader,
} from '@/utils/httpService'

import { getSessionId } from '../utils'

let sessionId = getSessionId()
if (!sessionId) {
  sessionId = v4()
  Cookies.set('session_id', sessionId)
}

const useAppInit = () => {
  const [isEmailVerified, setIsEmailVerified] = useState(true)
  const [token, setToken] = useState<string | null>(null)

  const dispatch = useDispatch()
  const { isLoading, loginWithRedirect, getIdTokenClaims, isAuthenticated } =
    useAuth0()

  const setAuthorizationHeader = useCallback(async () => {
    try {
      const tokenClaims = await getIdTokenClaims()
      if (tokenClaims?.__raw) {
        setAuthorizationToDefaultHeaders(`Bearer ${tokenClaims.__raw}`)
        localStorage.setItem('auth', tokenClaims.__raw)
        setToken(tokenClaims.__raw)
        setIsEmailVerified(tokenClaims?.email_verified || false)
        const lang = localStorage.getItem('i18nCode') || 'en'
        i18n.changeLanguage(lang)
        setHeader(HeaderKey.LANGUAGE, lang)
      } else {
      }
    } catch (error) {}
  }, [getIdTokenClaims, isAuthenticated])

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      setAuthorizationHeader()
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, setAuthorizationHeader])

  useEffect(() => {
    dispatch(checkAndClearDualCanvas())
  }, [dispatch])
  return {
    isLoading,
    token,
    isAuthenticated,
    loginWithRedirect,
    getIdTokenClaims,
    isEmailVerified,
  }
}

export default useAppInit
